/**
 * H1.js
 * Styled Component for H1
 */
import styled from 'styled-components'

// Styles
const Heading1 = styled.h1`
    color: ${props => props.theme.colors.headingColor};
`

export default Heading1;